module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "job-overview m-t-lg m-b-lg"
  }, [_c('h2', [_c('i', {
    staticClass: "far fa-truck"
  }), _vm._v(" Jobs\n    "), (_vm.$user.isEnabled && _vm.$user.isActivated) ? _c('router-link', {
    staticClass: "material-plus job-new",
    attrs: {
      "to": {
        name: 'jobs.create'
      }
    }
  }, [_vm._v("\n      +\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-job"
  }, [_vm._l((_vm.jobs), function(job) {
    return _c('job-item', {
      key: job.id,
      attrs: {
        "job": job
      }
    })
  }), _vm._v(" "), (_vm.haveNoJobs) ? _c('li', {
    staticClass: "text-center text-muted"
  }, [_c('strong', [_vm._v("No jobs found.")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'jobs.index'
      }
    }
  }, [_vm._v("View All Jobs")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-5efff5ae"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/JobList.vue
// module id = 1017
// module chunks = 0